import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { TypographyProps } from '@mui/material/Typography/Typography'

interface DescriptionTitleProps extends TypographyProps {}

export default function DescriptionTitle({ children, sx, ...props }: DescriptionTitleProps) {
	const theme = useTheme()
	return (
		<Typography
			variant="body2"
			color={theme.palette.text.primary}
			textAlign="left"
			sx={{
				fontSize: '13pt',
				lineHeight: '20pt',
				marginBottom: '16px',
				width: '100%',
				...sx,
			}}
			{...props}
		>
			{children}
		</Typography>
	)
}
